import { TableBody } from '@mui/material';

import { GDMTableBodyComponent } from './GDMTableBody.type';

/* TODO: Implement component using GDM default design */
const GDMTableBody: GDMTableBodyComponent = props => <TableBody {...props} />;

export default GDMTableBody;
